// Units which represent hours, their quantities are shown as h:mm
const HOUR_UNITS = ['uur', 'uren', 'u', 'h', 'hr', 'hrs', 'hour', 'hours', 'std', 'stunde', 'stunden'];

// Tell whether a line unit represents hours
export const isHourUnit = (unit?: string | null): boolean => {
    return !!unit && HOUR_UNITS.includes(unit.trim().toLowerCase());
};

// Format a decimal number of hours as h:mm, for example 0.5167 becomes 0:31
export const formatHoursQuantity = (hours: number): string => {
    const totalMinutes = Math.round(Math.abs(hours) * 60);
    const wholeHours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours < 0 ? '-' : ''}${wholeHours}:${minutes.toString().padStart(2, '0')}`;
};

// Parse an h:mm notation into a decimal number of hours, returns null for other input
export const parseHoursQuantity = (input: string): number | null => {
    const match = input.trim().match(/^(-?)(\d+):([0-5]?\d)$/);
    if (!match) return null;
    const hours = parseInt(match[2], 10) + parseInt(match[3], 10) / 60;
    return match[1] ? -hours : hours;
};
